<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import ImportForm from '@components/import-form'
import Multiselect from 'vue-multiselect'
import moment from "moment";

export default {

    page: {
        title: 'Новая задача',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader, Multiselect, ImportForm },

    data() {
        return {
            title: 'Новая задача',
            items: [],
            task_uuid: '',
            name: '',
            notify_email: null,
            trackBy: 'id',

            call_params: {
                attempts: 1,
                time_retries: 10,
                delayed: false,
                delayed_at: null,
            },

            initStatus: [],
            status: null,
            status_options: [
                { id: 'created',   name: 'Новая' },
                { id: 'preparing', name: 'Подготовка' },
                { id: 'active',    name: 'Активна' },
                { id: 'paused',    name: 'Отложена' },
                { id: 'success',   name: 'Выполнена' },
                { id: 'canceled',  name: 'Отменена' },
                { id: 'archive',   name: 'В архиве' },
                { id: 'stopped',   name: 'Остановлена' },
            ],

            initType: [],
            type: null,
            types_options: [
                { id: 'call', name: 'Позвонить' },
            ],

            initBot: [],
            bot: null,
            bots_options: [],

            trunk: null,
            initTrunk: [],
            trunks_options: [],

            initSkill: [],
            skill: null,
            skills_options: [],

            contact_category: null,
            initContactCategory: [],
            contacts_categories_options: [],

            contact_category_name: 'Обзвон ' + moment().format('DD.MM.YYYY'),
            contact_category_id: null,

            isSubmitErrorData: null,
            alertMessage: null,
            alertVariant: null
        }
    },

    watch: {

        initTrunk: {
            immediate: true,
            handler(values) {
                this.trunk = this.trunks_options.filter(x => values.includes(x[this.trackBy]));
                this.trunk = this.trunk[0];
            }
        },

        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },

        initType: {
            immediate: true,
            handler(values) {
                this.type = this.types_options.filter(x => values.includes(x[this.trackBy]));
                this.type = this.type[0];
            }
        },

        initBot: {
            immediate: true,
            handler(values) {
                this.bot = this.bots_options.filter(x => values.includes(x[this.trackBy]));
                this.bot = this.bot[0];
            }
        },

        initSkill: {
            immediate: true,
            handler(values) {
                this.skill = this.skills_options.filter(x => values.includes(x[this.trackBy]));
                this.skill = this.skill[0];
            }
        },

        initContactCategory: {
            immediate: true,
            handler(values) {
                this.contact_category = this.contacts_categories_options.filter(x => values.includes(x[this.trackBy]));
                this.contact_category = this.contact_category[0];
            }
        }
    },

    computed: {
        task_item(){
            return this.$store.getters['tasks/GET_TASKS_ITEM'];
        },
        bots_list_data(){
            return this.$store.getters['bots/GET_BOTS_LIST_DATA'];
        },
        skills_list_data(){
            return this.$store.getters['skills/GET_SKILLS_LIST_DATA'];
        },
        trunks_list_data(){
            return this.$store.getters['trunks/GET_TRUNKS_LIST_DATA'];
        },        
        contacts_categories_list_data(){
            return this.$store.getters['contactsCategories/GET_CONTACTS_CATEGORIES_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        // 20.10.2026: интервалы повторов списком «10; 1440; 10» — каждое число через сколько минут после предыдущей попытки
        retry_plan(){
            return this.planRetries(this.call_params.time_retries);
        },
        retry_schedule(){
            let attempts = parseInt(this.call_params.attempts) || 1;
            let minutes = this.retry_plan.minutes;
            if(attempts <= 1 || minutes.length === 0){
                return [];
            }
            let lines = ['1-я попытка: при запуске задачи'];
            let show = Math.min(attempts, 10);
            for(let i = 2; i <= show; i++){
                let m = minutes[Math.min(i - 2, minutes.length - 1)];
                lines.push(i + '-я: через ' + this.humanMinutes(m) + ' после ' + (i - 1) + '-й');
            }
            if(attempts > show){
                lines.push('и так же до ' + attempts + '-й');
            }
            return lines;
        },
    },

    async mounted() {

        this.task_uuid = this.$route.params.task_uuid ? this.$route.params.task_uuid : '';

        this.initType = ['call'];

        if(this.session_user_item && this.session_user_item.role !== 'administrator'){
            this.status_options = [
                { id: 'created',   name: 'Новая' },
                { id: 'active',    name: 'Активна' },
                { id: 'success',   name: 'Выполнена' },
                { id: 'canceled',  name: 'Отменена' },
                { id: 'stopped',   name: 'Остановлена' },
            ];

            if(this.task_uuid === ''){
                this.status_options = [
                    { id: 'created',   name: 'Новая' },
                ];
            }
        }

        await this.$store.dispatch('bots/FETCH_BOTS_LIST', {'sortBy': 'id', 'sortDesc': 'DESC', 'limit': 500});
        this.bots_options = this.bots_list_data;
        this.bot = this.bots_options && this.bots_options[0] ? this.bots_options[0] : null;

        // await this.$store.dispatch('skills/FETCH_SKILLS_LIST', {'sortBy': 'id', 'sortDesc': 'DESC', 'limit': 1000});
        // this.skills_options = this.skills_list_data;

        await this.$store.dispatch('contactsCategories/FETCH_CONTACTS_CATEGORIES_LIST', {'sortBy': 'id', 'sortDesc': 'DESC', 'limit': 100});
        this.contacts_categories_options = this.contacts_categories_list_data.slice();
        this.contacts_categories_options.unshift({ id:'new_contacts_category', name:'- новая группа контактов' });
    
        await this.$store.dispatch('trunks/FETCH_TRUNKS_LIST', {'sortBy': 'id', 'sortDesc': 'DESC', 'limit': 500});
        this.trunks_options = this.trunks_list_data;
        this.trunk = this.trunks_options && this.trunks_options[0] ? this.trunks_options[0] : null;
        
        this.status = 'created';
        this.initStatus = [this.status];

        if(this.task_uuid !== ''){

            this.title = 'Редактирование задачи';
            document.title = appConfig.title + ' - ' + 'Редактирование задачи';

            let data_send = {
                'uuid' : this.task_uuid
            }

            await this.$store.dispatch('tasks/FETCH_TASKS_ITEM', data_send);

            this.name = this.task_item.name ? this.task_item.name : '';
            this.notify_email = this.task_item.notify_email ? this.task_item.notify_email : null;

            this.status = this.task_item.status ? this.task_item.status : '';
            this.initStatus = [this.status];

            this.type = this.task_item.type ? this.task_item.type : '';
            this.initType = [this.type];

            this.bot = this.task_item.bot_id ? this.task_item.bot_id : '';
            this.initBot = [this.bot];

            this.trunk = this.task_item.trunk_id ? this.task_item.trunk_id : '';
            this.initTrunk = [this.trunk];

            this.skill = this.task_item.skill_id ? this.task_item.skill_id : '';
            this.initSkill = [this.skill];

            let task_call_params = this.task_item.more_data ? JSON.parse(this.task_item.more_data) : false;
            task_call_params = task_call_params.call_params;            

            if(task_call_params){
                this.call_params.attempts = task_call_params.attempts;
                this.call_params.time_retries = task_call_params.time_retries;
                this.call_params.delayed = task_call_params.delayed;
                this.call_params.delayed_at = task_call_params.delayed_at;
            }

            this.contact_category = this.task_item.contact_category_id ? this.task_item.contact_category_id : null;
            if (this.contact_category !== null) {
                this.initContactCategory = [this.contact_category];
            }
        }
    },

    methods: {

        // «10», «1d», «2h», «1h 30m» → минуты; непонятное → null (сервер понимает те же записи)
        parseRetryMinutes(part){
            let p = String(part).trim().toLowerCase();
            if(/^\d+$/.test(p)){
                return parseInt(p);
            }
            if(/^(\d+\s*[mhd]\s*)+$/.test(p)){
                let total = 0;
                let re = /(\d+)\s*([mhd])/g;
                let x;
                while((x = re.exec(p)) !== null){
                    total += parseInt(x[1]) * (x[2] === 'd' ? 1440 : (x[2] === 'h' ? 60 : 1));
                }
                return total;
            }
            return null;
        },

        planRetries(value){
            let raw = value === null || value === undefined ? '' : String(value);
            let minutes = [];
            let bad = [];
            raw.split(/[;,]+/).map(x => x.trim()).filter(x => x !== '').forEach(part => {
                let m = this.parseRetryMinutes(part);
                if(m === null){
                    bad.push(part);
                } else {
                    minutes.push(m);
                }
            });
            return { minutes, bad };
        },

        humanMinutes(m){
            if(m < 60){
                return m + ' мин';
            }
            let h = Math.floor(m / 60);
            let rest = m % 60;
            return m + ' мин (' + h + ' ч' + (rest ? ' ' + rest + ' мин' : '') + ')';
        },

        // если чисел в списке больше, чем повторов, сразу добавляем попытки, чтобы все интервалы сработали
        onRetriesInput(value){
            let plan = this.planRetries(value);
            let k = plan.minutes.length;
            if(plan.bad.length === 0 && k > 1 && (parseInt(this.call_params.attempts) || 1) < k + 1){
                this.call_params.attempts = k + 1;
            }
        },

        async generateName(){

            let name = '';

            if(this.type && this.type.id && this.type.id === 'call'){
                name = 'Обзвонить группу контактов'
            }

            if(this.contact_category && this.contact_category.name ){
                if(this.contact_category.id !== 'new_contacts_category'){
                    name = name + ': ' + this.contact_category.name;
                } else {
                    name = name + ': ' + this.contact_category_name;
                }                
            }

            return name;
        },

        async importContacts(category_id){
            return this.$refs.import_form.importData(category_id);
        },

        async saveItem(){

            let err = false;
            let err_message = '';

            if(!this.type || !this.type.id){
                err = true;
                err_message = 'Тип задач';
            }
            if(!this.bot || !this.bot.id){
                err = true;
                if(err_message !== ''){
                    err_message = err_message + ', ';
                } 
                err_message = err_message + 'Ответственный';
            }
            if(!this.trunk || !this.trunk.id){
                err = true;
                if(err_message !== ''){
                    err_message = err_message + ', ';
                }
                err_message = err_message + 'Транк';
            }
            if(!this.contact_category || !this.contact_category.id){
                err = true;
                if(err_message !== ''){
                    err_message = err_message + ', ';
                }
                err_message = err_message + 'Группа контактов';
            }
            if(this.contact_category && this.contact_category.id && this.contact_category.id === 'new_contacts_category' && (this.contact_category_name === '' || this.contact_category_name === null)){
                err = true;
                if(err_message !== ''){
                    err_message = err_message + ', ';
                }
                err_message = err_message + 'Название группы контактов';
            }
            if(!this.status || !this.status.id){
                err = true;
                if(err_message !== ''){
                    err_message = err_message + ', ';
                }
                err_message = err_message + 'Статус';
            }
            if(this.type && this.type.id === 'call' && (parseInt(this.call_params.attempts) || 1) > 1 && (this.retry_plan.bad.length > 0 || this.retry_plan.minutes.length === 0)){
                err = true;
                if(err_message !== ''){
                    err_message = err_message + ', ';
                }
                err_message = err_message + 'Через сколько минут повторять (числа минут через точку с запятой)';
            }

            if(err === true){
                this.isSubmitErrorData = true;
                this.alertMessage = 'Не все обязательные поля были заполнены: ' + err_message;
                this.alertVariant = 'danger';

                return false;
            } 

            if(this.contact_category && this.contact_category.id && this.contact_category.id === 'new_contacts_category'){

                // Добавляем новую группу контактов
                let new_contact_category_data = {
                    'name': this.contact_category_name,
                }
                let new_contact_category = await this.$store.dispatch('contactsCategories/FETCH_CONTACTS_CATEGORIES_CREATE', new_contact_category_data);    
                this.contact_category_id = new_contact_category.id;

                // Добавляем задачу на загрузку контактов
                let result_import = await this.importContacts(this.contact_category_id);
                if(result_import === false){
                    return false;
                }
            }

            // сохраняем интервалы в минутах: «1d; 2h» → «1440; 120»
            if(this.retry_plan.bad.length === 0 && this.retry_plan.minutes.length > 0){
                this.call_params.time_retries = this.retry_plan.minutes.length === 1 ? this.retry_plan.minutes[0] : this.retry_plan.minutes.join('; ');
            }

            let data_send = {
                'name'     : await this.generateName(),
                'status'   : this.status && this.status.id ? this.status.id : null,
                'type'     : this.type   && this.type.id   ? this.type.id   : null,
                'bot_id'   : this.bot    && this.bot.id    ? this.bot.id    : null,
                'skill_id' : this.skill  && this.skill.id  ? this.skill.id  : null,
                'trunk_id' : this.trunk  && this.trunk.id  ? this.trunk.id  : null,
                'more_data': JSON.stringify({
                    'call_params': this.call_params
                }),
                'notify_email': this.notify_email
            };

            if(this.contact_category.id !== 'new_contacts_category'){
                data_send['contact_category_id'] = this.contact_category && this.contact_category.id ? this.contact_category.id : null;
            } else {
                data_send['contact_category_id'] = this.contact_category_id;
            }

            let result = '';

            if(this.task_uuid === ''){
                result = await this.$store.dispatch('tasks/FETCH_TASKS_CREATE', data_send);
            } else {
                data_send.uuid = this.task_uuid;
                result = await this.$store.dispatch('tasks/FETCH_TASKS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Tasks'});
            }
        }
    },
}

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <div class="row">
                            <div class="col">
                                <b-alert
                                    v-model="isSubmitErrorData"
                                    :variant="alertVariant"
                                    dismissible
                                >{{ alertMessage }}</b-alert>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 20px">
                            <div class="col">
                               <span style="font-weight: bold">* - поля обязательные к заполнению</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">

                                <b-form-group
                                    v-if="session_user_item.role === 'administrator'"
                                    label="Тип задачи *"
                                    label-for="type"
                                >
                                    <multiselect
                                        id="type"
                                        :track-by="trackBy"
                                        v-model="type"
                                        :options="types_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                    ></multiselect>
                                </b-form-group>
                                
                                <div style="margin-bottom: 15px">
                                    <label for="bot">Ответственный бот * 
                                        <a href="#" class="btn btn-white" style="font-weight: bold; padding: 0px; font-size: 11px; border-radius: 10px; padding-top: 1px; width: 20px; height: 19px" v-b-tooltip.right="'Выберите бота, который будет осуществлять текущий обзвон'">?</a>
                                    </label>
                                    <multiselect
                                        id="bot"
                                        :track-by="trackBy"
                                        v-model="bot"
                                        :options="bots_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                    ></multiselect>
                                </div>

                                <div v-if="type && type.id && type.id === 'call'">
                                    
                                    <b-form-group
                                        label="Транк *"
                                        label-for="trunk"
                                    >
                                        <multiselect
                                            id="trunk"
                                            :track-by="trackBy"
                                            v-model="trunk"
                                            :options="trunks_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <div class="row">
                                        <div class="col-sm-12 col-xl-6">                                            
                                            <label for="attempts">Попыток дозвона
                                                <a href="#" class="btn btn-white" style="font-weight: bold; padding: 0px; font-size: 11px; border-radius: 10px; padding-top: 1px; width: 20px; height: 19px" v-b-tooltip.right="'Сколько всего раз бот позвонит, если абонент не ответил. Первый звонок тоже считается: 3 попытки = первый звонок и 2 повтора. Рекомендуем 2 или 3'">?</a>
                                            </label>
                                            <b-form-input
                                                id="attempts"
                                                v-model="call_params.attempts"
                                                placeholder="1"
                                            ></b-form-input>
                                        </div>

                                        <div class="col-sm-12 col-xl-6">
                                            <label for="time_retries">Через сколько минут повторять
                                                <a href="#" class="btn btn-white" style="font-weight: bold; padding: 0px; font-size: 11px; border-radius: 10px; padding-top: 1px; width: 20px; height: 19px" v-b-tooltip.right="'Одно число: все повторы через это время. Несколько чисел через точку с запятой: своё время для каждого повтора, считается от предыдущей попытки'">?</a>
                                            </label>
                                            <b-form-input
                                                id="time_retries"
                                                v-model="call_params.time_retries"
                                                placeholder="10; 1440; 10"
                                                @input="onRetriesInput"
                                            ></b-form-input>
                                            <small class="form-text text-muted">
                                                Одно число или список через точку с запятой, например 10; 1440; 10.
                                                Каждое число: через сколько минут после предыдущей попытки.
                                                1 час = 60, 3 часа = 180, 24 часа = 1440, 2 суток = 2880 минут.
                                            </small>
                                            <small v-if="retry_plan.bad.length" class="form-text text-danger">
                                                Не понял: {{ retry_plan.bad.join(', ') }}. Пишите число минут, например сутки = 1440.
                                            </small>
                                        </div>
                                    </div>

                                    <div v-if="retry_schedule.length" class="text-muted" style="margin-top: 10px; font-size: 12px">
                                        <div style="font-weight: bold">Как будет звонить, если абонент не ответил:</div>
                                        <div v-for="(line, i) in retry_schedule" :key="i">{{ line }}</div>
                                        <div style="margin-top: 4px">Повтор только при недозвоне: не ответили, занято, автоответчик. Ночью не звоним: повтор ждёт 9 утра по времени абонента.</div>
                                    </div>
                        
                                    <b-form-checkbox v-model="call_params.delayed" name="config_record" style="margin-top: 15px; margin-bottom: 15px" switch>
                                        Отложенный звонок <a href="#" class="btn btn-white" style="font-weight: bold; padding: 0px; font-size: 11px; border-radius: 10px; padding-top: 1px; width: 20px; height: 19px" v-b-tooltip.right="'Возможность запустить звонки в указанную дату и время'">?</a>
                                    </b-form-checkbox>
                        
                                    <b-form-group
                                        v-if="call_params.delayed"
                                        label="Дата и время звонка"
                                        label-for="delayed_at"
                                    >
                                        <b-form-input
                                            id="delayed_at"
                                            v-model="call_params.delayed_at"
                                            placeholder="00:00:00 01.01.2022"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>                                
                                
                                <div style="margin-bottom: 15px">
                                    <label for="contact_category">Группа контактов *
                                        <a href="#" class="btn btn-white" style="font-weight: bold; padding: 0px; font-size: 11px; border-radius: 10px; padding-top: 1px; width: 20px; height: 19px" v-b-tooltip.right="'База номеров для текущего обзвона из загружаемого файла'">?</a>
                                    </label>
                                    <multiselect
                                        id="contact_category"
                                        :track-by="trackBy"
                                        v-model="contact_category"
                                        :options="contacts_categories_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                    ></multiselect>
                                </div>                                                                    

                                <b-form-group
                                    v-if="contact_category && contact_category.id && contact_category.id === 'new_contacts_category'"
                                    label="Название группы контактов"
                                    label-for="contact_category_name"
                                >
                                    <b-form-input
                                        id="contact_category_name"
                                        v-model="contact_category_name"
                                        placeholder="Укажите название новой группы контактов"
                                    ></b-form-input>
                                </b-form-group>

                                <ImportForm 
                                    v-if="contact_category && contact_category.id && contact_category.id === 'new_contacts_category'" 
                                    v-bind:type="'task'"
                                    ref="import_form"
                                    style="margin-top: 30px; margin-bottom: 30px"
                                />

                                <b-form-group
                                    v-if="session_user_item.role === 'administrator' || (task_uuid !== '' && task_uuid !== null)"
                                    label="Статус *"
                                    label-for="status"
                                >
                                    <multiselect
                                        id="status"
                                        :track-by="trackBy"
                                        v-model="status"
                                        :options="status_options"
                                        placeholder="Выберите из списка"
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                    ></multiselect>
                                </b-form-group>

                                <b-form-group
                                    label="Результаты отправить на e-mail"
                                    label-for="notify_email"
                                >
                                    <b-form-input
                                        id="notify_email"
                                        v-model="notify_email"
                                        placeholder="Укажите e-mail"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
